export class LotteryRuleContent {
  static content: string[] = [
    "1.活动周期为一周，包括准备期和开奖日，周一到周六为准备期，周日为开奖日。",
    "2.用户在准备期可消耗积分兑换幸运码，兑换的幸运码越多，中奖概率越大。",
    "3.开奖日会根据算法抽取中奖的幸运码，持有获奖幸运码的用户将获得奖品。",
    "4.开奖后，未中奖的用户将获得幸运值，兑换了几张幸运码即可获得几点幸运值，幸运值集满，可获得幸运奖品；中奖用户的幸运值将清零，重新计算。",
    "5.用户的幸运值集满，领取幸运奖品后，幸运值清零，重新计算；若不领取幸运奖品，将无法继续增加。"
  ];
  static contentBlack: string[] = [
    "1.活动周期为",
    "，包括准备期和开奖日，周一到周六为准备期，",
    "为开奖日。"
  ];
  static contentRed: string[] = ["一周", "周日", ""];

  static description: string[] = [
    "1.开奖后，中奖用户需在开奖日当天如实填写收货信息。若错过领奖时间或填写信息有误导致没有收到奖品，我们将不承担任何责任。",
    "2.若参与本期活动的人数少于100人，本期活动将取消开奖，参与活动的用户将获得幸运值。",
    "3.幸运值集满后，用户领取奖品时需如实填写收货信息，若填写信息有误导致没有收到奖品，我们将不承担任何责任。"
  ];
  static descriptionBlack: string[] = [
    "2.若参与本期活动的人数",
    "，本期活动将取消开奖，参与活动的用户将获得幸运值。"
  ];
  static descriptionRed: string[] = ["少于100人", ""];

  static algorithm: string[] = [
    "本期中奖幸运码序号 ",
    "=取余（N/本期幸运码数量）+1",
    "=本期活动期数+本期最后一张幸运码的时间戳",
    "对本期幸运码数量取余后，余数范围比本期幸运码数量少1，所以需要在取余之后加1。",
    "是由幸运码的兑换时间按照确定的方法转换而来的，是一个13位的数字。",
    "",
    "本期为第5期活动，本期最后一张幸运码的时间戳为1600841703374，本期活动参与者共兑换了10034个幸运码。 1600841703374加上5等于1600841703379，1600841703379除以10034的余数是4627， 4627再加1等于4628，序号为4628的幸运码即为中奖幸运码。"
  ];

  static algorithmBlack: string[] = ["", "", "", "用"];
  static algorithmRed: string[] = ["", "", "N", "N", "时间戳", "", "例："];

  static precautions: string[] = [
    "1.幸运码兑换时间截止到本周六23:59，开奖日将无法兑换幸运码。",
    "2.所有奖品均由活动主办方选定，用户收到奖品后，若无质量问题，将无法退换奖品。",
    "3.在参与活动过程中，如存在违规行为（包括但不限于非真实手机设备、利用系统漏洞、黑客工具、软件作弊等非正常方式），活动主办方将取消违规账号的参与活动及获得奖励的资格；违规行为的具体认定以活动主办方判定为准。"
  ];
}
